import React from "react";
import { Icon } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";

import {
  ChartTypes,
  DateUnits,
  ISeries,
  ITrendDataLimit,
  Trend,
  TrendMarkerTypes,
} from "@iom/trend";
import _ from "lodash";
import { MeasurementSetting } from "../../models/settings/MeasurementSettings";
import utility from "../shared/Utility";
import { Translation } from "react-i18next";
import { Status } from "../../models/sample/Status";
import {
  defaultKeyedInDetails,
  IKeyedInDetails,
} from "../../models/measurement/KeyedInDetails";
import triggerNotifications from "../../utilities/TriggerNotifications";
import measurementActions from "../../flux/actions/MeasurementActions";
import { v4 as uuidv4 } from "uuid";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import keyedInCountStore from "../../flux/stores/measurement/KeyedInCountStore";
import KeyedInDetailsStore from "../../flux/stores/measurement/KeyedInDetailStore";

interface ILandingprops {
  showKeyedInProperty: (data: any) => void;
  showKeyedInPropertyDetails: (data: any) => void;
  selectedKeyedInDetails: any;
  thresholdSettings: any;
  keyedInSampleData: any;
  countValue: any;
  sampleDataDummy: any;
  measurementIdDummy: any;
  keyInCompletedHandeler: any;
}

interface IState {
  dummyState: any;
  toggleGraph: boolean;
  series: any;
  chartType: ChartTypes;
  dateUnit: DateUnits;
  dateUnitCount: number;
  start?: Date;
  end?: Date;
  decimal: number;
  keyedInCountData?: any;
  prevStateValue?: any;
}

export default class KeyedInProperty extends React.Component<
  ILandingprops,
  IState
> {
  private _countIndex = 0;
  private start = new Date(2019, 0, 1, 0, 0, 0, 0);
  private end = new Date(2019, 0, 5, 0, 0, 0, 0);
  private minXValue: number;
  private maxXValue: number;
  private _autolineScroll: any;
  private _mount: boolean;
  private _hasData: boolean = true;
  private _page: any = 1;
  private _isautoFocus: Boolean = true;
  private setFocus: string = '';
  private _KeyedInCountData: any;
  private readonly OK = 200;
  private readonly CREATED = 201;
  private _keyedInDetails: any;

  constructor(props: any) {
    super(props);
    this._autolineScroll = React.createRef();

    let xValue: number[] = [];

    this.minXValue = 0;
    this.maxXValue = 200;

    this.state = {
      dummyState: null,
      toggleGraph: false,
      chartType: "Bar",
      dateUnit: "Day",
      dateUnitCount: 4,
      start: this.start,
      end: this.end,
      series: [
        {
          name: "Position",
          color: "#5ABFAE",
          id: "1",
          markerStyle: {
            type: this.state?.chartType === "Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: this.minXValue,
            max: this.maxXValue,
            decimalPlaces: 0,
          },
          isShownInChart: true,
          points: this.generateOrdinalData1(0, 20, 1, 0, 100),
        },
      ],
      decimal: 5,
      keyedInCountData: 1,
      prevStateValue: ""
    };
  }

  generateOrdinalData1(
    fromDate: number,
    toDate: number,
    interval = 1,
    min: number,
    max: number,
    isNumber = false
  ) {
    const data = [
      {
        xValue: "Position",
        value: 50,
      },
    ];
    return data;
  }

  onChartTypeChange = (chartType: ChartTypes) => {
    this.setState({
      chartType: chartType,
    });
    return chartType;
  };

  onSeriesChartTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, chartType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesColorChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, color: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  getMarkerStyles = (value: string, item: ISeries) => {
    let marker = item.markerStyle ? { ...item.markerStyle } : {};
    if (value === "Circle") {
      marker.type = "Circle";
      marker.fillColor = "white";
    } else if (value === "Square") {
      marker.type = "Square";
      marker.fillColor = "white";
    } else if (value === "FillCircle") {
      marker.type = "Circle";
      marker.fillColor = "SeriesColor";
    } else if (value === "FillSquare") {
      marker.type = "Square";
      marker.fillColor = "SeriesColor";
    } else {
      marker.type = "None";
    }
    return marker;
  };

  onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return {
          ...item,
          markerStyle: { ...series.markerStyle, type: value },
        } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesFillTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, fillType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onInvalidPointTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, invalidPointLineType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      dateUnit,
      dateUnitCount,
      start: start as Date,
      end: end as Date,
    });
  };

  onDataLimitVisibilityChange = (
    series: ISeries,
    limit: ITrendDataLimit,
    isShown: boolean
  ) => {
    let updatedValue = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        let limits = item.dataLimits.map((line: ITrendDataLimit) => {
          if (line.name === limit.name) {
            return { ...line, shownInChart: isShown };
          } else {
            return line;
          }
        });
        return { ...item, dataLimits: limits };
      } else {
        return item;
      }
    });

    this.setState({ series: updatedValue });
  };

  /// default color is black
  private getRightColorForDashboardView(
    allValueRangesForAPosition: any[]
  ): string {
    let color = CONSTANTS.WITHIN_LIMIT_COLOR;
    if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit1
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit1"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit2
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit2"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.RejectLimit
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Reject Limit"
      )?.colorCode;
    }
    return color;
  }

  private keyedInRowData = () => {
    const items: any = [];

    (this.state.dummyState.countData || []).forEach((data: any, i: any) => {
      const meanData = this.props.selectedKeyedInDetails.positionMeans.find(
        (x: any) => x.position === data.position
      ); // TODO need a fix multiple comes

      var allValueRangesForAPosition: any[] = [];
      this.state.dummyState.dashboardReading.forEach((x: any) => {
        if (data !== undefined) {
          if (x.positionName === data.positionName && x.position === i) {
            allValueRangesForAPosition.push(x);
          }
        }
      });
      var color = this.getRightColorForDashboardView(
        allValueRangesForAPosition
      );
      const mean =
        meanData !== undefined && meanData.mean
          ? !isNaN(meanData?.mean)
            ? meanData.mean.toFixed(this.props.selectedKeyedInDetails?.decimals ?? 5)
            : CONSTANTS.NOTCONSIDEREDFORCALC
          : CONSTANTS.NOTCONSIDEREDFORCALC;

      items.push(
        <td key={i} className="text-align-center">
          <div>
            {mean === CONSTANTS.NOTCONSIDEREDFORCALC ? (
              <div style={{ color }}>{mean}</div>
            ) : (
              <div style={{ color }}>({mean})</div>
            )}
            <div>
              {this.createKeyedInData(i)}
            </div>
          </div>
        </td>
      );
    });

    return items;
  };

  private createKeyedInData = (i: any) => {
    const items: any[] = [];
    const propertyId =
      this.state.dummyState &&
        this.state.dummyState.propertyMean &&
        this.state.dummyState.propertyMean.propertyId
        ? this.state.dummyState.propertyMean.propertyId
        : this.state.dummyState.readings[0].propertyId;

    // input text button
    const selectedPosition = this.state.dummyState.positionCounts[i];
    const countData = this.state.dummyState.countData[i];
    const selectedDirection = countData.directions[0];

    for (let index = 0; index < selectedDirection.totalCounts; index++) {
      this._countIndex = this._countIndex + 1;
      const readings = this.state.dummyState.readings.find(
        (x: any) =>
          x.directionId === selectedDirection.id &&
          x.propertyId === propertyId &&
          x.count === index + 1 &&
          x.position === selectedPosition.position
      );
      const value = readings !== undefined ? String(readings.value) : "";
      if (this.setFocus === '' && value === "") {
        this.setFocus = `inpuField${i}${index}`
      }
      const indexVal = index + 1;
      const completed = this.state.dummyState.readings.find(
        (x: any) =>
          x.directionId === selectedDirection.id &&
          x.count === index + 1 &&
          x.position === selectedPosition.position
      );
      const compValue =
        completed === undefined
          ? false
          : completed.completed === undefined
            ? false
            : true;

      items.push(
        <div style={{ padding: "2px 0px" }}>
          <input
            type="text"
            id={`inpuField${i}${index}`}
            placeholder="Value"
            key={propertyId + "_" + selectedPosition.position + "_" + index}
            name={propertyId + "_" + selectedPosition.position + "_" + index}
            value={value}
            className={
              compValue
                ? "input-focus count-selected tableEdit"
                : "input-focus tableEdit"
            }
            tabIndex={this._countIndex}
            onChange={(e: any) =>
              this.onChangeKeyedInChild(
                e,
                indexVal,
                propertyId,
                {},
                selectedPosition.position,
                {
                  e,
                  value,
                  count: indexVal,
                  propertyId,
                  apiCall: true,
                  position: selectedPosition.position,
                },
                selectedDirection.id
              )
            }
            onKeyDown={(e: any) => this.changeFocus(e)}
            onBlur={(e: any) =>
              this.onblurInput(e, {
                value: e.target.value,
                count: indexVal,
                propertyId,
                apiCall: true,
                position: selectedPosition.position,
                id: selectedDirection.id
              })
            }
          />
        </div>
      );
    }
    return items;

  };

  changeFocus = (e: any) => {
    if (e.key.toLowerCase() === "enter") {
      const form = e.target.form;
      const index = [...form].indexOf(e.target);
      if (index === form.length - 1) {
        form.elements[index].blur();
      } else {
        form.elements[index + 1].focus();
      }
      this._isautoFocus = false;
      e.preventDefault();
    }
  };

  onKeyedInCountSubmit = (data: any) => {
    const selectedPosition = this.state.dummyState.positionCounts.find(
      (x: any) => x.position === data.position
    );
    const countData = this.state.dummyState.countData.find(
      (x: any) => x.position === data.position
    );
    const selectedDirection = countData.directions[0];
    const currentValue = data.value;

    const submitData = {
      sampleId: this.props.sampleDataDummy,
      propertyId: data.propertyId,
      measurementId: this.props.measurementIdDummy,
      position: selectedPosition.position,
      directionId: selectedDirection.id,
      count: data.count,
      value: Number(data.value),
    };
    if (currentValue === "" || currentValue == null) {
      triggerNotifications.error(CONSTANTS.KEYEDIN_VALUE);
      const dummyArray = { ...this.state.dummyState };
      const reading = dummyArray.readings.find(
        (x: any) =>
          x.directionId === data.id &&
          x.position === data.position &&
          x.propertyId === data.propertyId &&
          x.count === data.count
      );
      if (reading !== undefined || reading !== null) {
        if ((this.props.selectedKeyedInDetails.counts && this.props.selectedKeyedInDetails.counts.length && this.props.selectedKeyedInDetails.counts[0].totalCounts === this.props.selectedKeyedInDetails.counts[0].completedCounts) || (this.props.selectedKeyedInDetails.status.name &&
          this.props.selectedKeyedInDetails.status.name.toString() ===
          Status.COMPLETED)) {
          const readingIndex = dummyArray.readings.findIndex(
            (x: any) =>
              x.directionId === data.id &&
              x.position === data.position &&
              x.propertyId === data.propertyId &&
              x.count === data.count
          );
          reading.value = this.state.prevStateValue;
          dummyArray.readings[readingIndex] = reading;
        }
      }
    } else {
      measurementActions
        .postCountData(submitData, uuidv4())
        .then(() => {
          if (this.state.keyedInCountData === this.CREATED || this.state.keyedInCountData === this.OK) {
            if ((this.props.selectedKeyedInDetails.counts &&
              this.props.selectedKeyedInDetails.counts.length &&
              this.props.selectedKeyedInDetails.counts[0].totalCounts === this.props.selectedKeyedInDetails.counts[0].completedCounts)
              || (this.props.selectedKeyedInDetails.status.name &&
                this.props.selectedKeyedInDetails.status.name.toString() ===
                Status.COMPLETED)) {
              setTimeout(() => {
                this.props.showKeyedInProperty(this.props.selectedKeyedInDetails || "")
              },CONSTANTS.NOTIFICATION_TIMEOUT)
            }
          }
        })
        .catch((error: any) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };
  onblurInput = (e: any, data: any) => {
    this.onKeyedInCountSubmit(data);
  };

  onChangeKeyedInChild = (
    e: any,
    count: number,
    propertyId: string,
    item: any,
    position: any,
    objValue: any,
    id: any
  ) => {
    e.persist();
    const bool = /^-?\d*?\.?\d*$/g.test(e.target.value);
    let isDecimal = false;
    let prevStateValue: any = objValue.value;
    if (e.target.value.toString().length && e.target.value.toString().includes('.')) {
      let split = e.target.value.toString().split('.')
      isDecimal = split[1].length > this.state.decimal
    }
    if (!bool || isDecimal) {
      return;
    }
    const dummyArray = { ...this.state.dummyState };
    const reading = dummyArray.readings.find(
      (x: any) =>
        x.directionId === id &&
        x.position === position &&
        x.propertyId === propertyId &&
        x.count === count
    );
    if (reading === undefined || reading === null) {
      const data = {
        sampleId: "",
        propertyId,
        measurementId: "",
        position: position,
        directionId: id,
        count,
        value: e.target.value,
      };
      dummyArray.readings.push(data);
    } else {
      const readingIndex = dummyArray.readings.findIndex(
        (x: any) =>
          x.directionId === id &&
          x.position === position &&
          x.propertyId === propertyId &&
          x.count === count
      );
      reading.value = e.target.value;
      dummyArray.readings[readingIndex] = reading;
    }
    this.setState({
      dummyState: dummyArray,
      prevStateValue: prevStateValue
    });
  };
  componentDidMount() {
    this._mount = true;
    this.setState({ dummyState: this.props.selectedKeyedInDetails, decimal: Number(this.props.selectedKeyedInDetails?.decimals ?? 0) });
    keyedInCountStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._KeyedInCountData = state.status;
      this.setState({
        keyedInCountData: state.status,
      })
    });
    KeyedInDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._keyedInDetails = state.data;
    });
    setTimeout(() => {
      if (this._isautoFocus && document.getElementById(this.setFocus)) {
        document.getElementById(this.setFocus).focus();
      }
    }, 300);
    this.setState({
      chartType: measurementSettingStore.getChartType(),
    });
  }

  componentWillReceiveProps(nextProps: Readonly<ILandingprops>, nextContext: any): void {
    console.log(nextProps,this.props);
  }
  private keyedInGraphData = () => {
    const items: any[] = [];
    const trendData = [];
    let propertyDetails: any = {};

    if (1) {
      this.props.selectedKeyedInDetails.statistics
        .sort(utility.sortAlphaNum)
        .forEach((item: any) => {
          trendData.push({
            xValue: item.positionName
              ? item.positionName
              : (item.position + 1).toString(),
            value: item.mean != null && item.mean != "NaN" ? item.mean : 0,
          });
        });

      propertyDetails = this.props.keyedInSampleData.find(
        (x: any) => x.id == this.props.selectedKeyedInDetails.id
      );

      if (trendData.length != 0) {
        trendData.push({ xValue: "", value: null });
      }

      const yValue: number[] = [
        propertyDetails.alarmLow1,
        propertyDetails.alarmLow2,
        propertyDetails.alarmHigh1,
        propertyDetails.alarmHigh2,
        propertyDetails.rejectLow,
        propertyDetails.rejectHigh,
      ];
      trendData.forEach((item: any) => {
        yValue.push(item.value);
      });

      let minYValue: any = 0;
      let maxYValue: any = 0;

      if (Math.sign(_.min(yValue)) === -1) {
        minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
        maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
      } else {
        // ITC Changes
        minYValue =
          _.min(_.without(yValue, 0)) - (_.min(_.without(yValue, 0)) / 100) * 5;
        maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
      }

      const series1: any = [
        {
          name: "Mean",
          color: "#5ABFAE",
          id: "1",
          markerStyle: {
            type: this.state?.chartType === "Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: minYValue,
            max: maxYValue,
            decimalPlaces: propertyDetails?.decimals,
          },
          dataLimits: [
            {
              name: "Alarm Low Limit-1",
              shownInChart: true,
              value: propertyDetails.alarmLow1,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                ).colorCode,
              },
            },
            {
              name: "Alarm High Limit-1",
              shownInChart: true,
              value: propertyDetails.alarmHigh1,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                ).colorCode,
              },
            },
            {
              name: "Alarm Low Limit-2",
              shownInChart: true,
              value: propertyDetails.alarmLow2,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                ).colorCode,
              },
            },
            {
              name: "Alarm High Limit-2",
              shownInChart: true,
              value: propertyDetails.alarmHigh2,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                ).colorCode,
              },
            },
            {
              name: "Reject Low",
              shownInChart: true,
              value: propertyDetails.rejectLow,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Reject Low" || x.name === "Reject Limit"
                ).colorCode,
              },
            },
            {
              name: "Reject High",
              shownInChart: true,
              value: propertyDetails.rejectHigh,
              className: "custom-line-graph",
              style: {
                stroke: this.props.thresholdSettings?.find(
                  (x: any) =>
                    x.name === "Reject High" || x.name === "Reject Limit"
                ).colorCode,
              },
            },
          ],
          isShownInChart: true,
          points: trendData,
        },
      ];

      items.push(
        <tr
          style={{ height: "150px" }}
          className="normal-class"
          key={Math.random()}
        >
          <td>
            <span>{this.props.selectedKeyedInDetails.name}</span>
            {this.props.selectedKeyedInDetails?.propertyMean?.mean ? (
              <span className="float-right">
                (
                {this.props.selectedKeyedInDetails?.propertyMean?.mean.toFixed(
                  this.props.selectedKeyedInDetails?.decimals ?? 5
                )}
                )
              </span>
            ) : (
              <span className="float-right">
                {CONSTANTS.NOTCONSIDEREDFORCALC}
              </span>
            )}
            <span className="float-right pr-4">
              {this.props.selectedKeyedInDetails.unit}
            </span>
          </td>
          <td
            className="trend-table"
            colSpan={this.props.selectedKeyedInDetails?.positionCounts?.length}
          >
            {series1[0].points?.length > 0 ? (
              <Trend
                chartType={this.state.chartType}
                invalidPointLineType="None"
                invalidStatuses={["Invalid"]}
                dateUnit={this.state.dateUnit}
                dateUnitCount={this.state.dateUnitCount}
                gridLineColor="grey"
                gridLineWidth={0.5}
                showVerticalGridLines={false}
                showHorizontalGridLines={true}
                series={series1}
                xAxis={{ type: "Ordinal", tickAngle: 45, height: 15 }}
                onChartTypeChange={this.onChartTypeChange}
                onDataLimitVisibilityChange={this.onDataLimitVisibilityChange}
                onDateRangeChange={this.onDateRangeChange}
                onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                onSeriesColorChange={this.onSeriesColorChange}
                onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                onSeriesMarkerChange={this.onSeriesMarkerChange}
                trendChartHeight={150}
                showChartType={false}
                showDateTimePicker={false}
                showOuterBorder={false}
                showTableData={false}
                yAxisTicksCount={2}
                yAxisWidth={75}
              />
            ) : (
              <div>
                <NoTrendToDisplay></NoTrendToDisplay>
              </div>
            )}
          </td>
        </tr>
      );
      return items;
    } else {
      return null;
    }
  };

  toggleGraphView = () => {
    this.setState({
      toggleGraph: !this.state.toggleGraph,
    });
  };
  render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="col-12">
              <button
                title="back"
                className="icon-button circle"
                onClick={(e) => this.props.showKeyedInProperty(this.props.selectedKeyedInDetails || "")}
              >
                <Icon name="abb/left" sizeClass="small" />
              </button>
              <ul className="navbar-nav propertyFilterList">
                {this.state.toggleGraph ? (
                  <button
                    title={t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                    className={
                      this.state.toggleGraph
                        ? "icon-button circle active"
                        : "icon-button circle"
                    }
                    onClick={this.toggleGraphView}
                  >
                    <Icon name="abb/list" sizeClass="small" />
                  </button>
                ) : (
                  <button
                    title={t(CONSTANTS.TITLE_TESTOVERVIEW_GRAPH)}
                    className={
                      this.state.toggleGraph
                        ? "icon-button circle active"
                        : "icon-button circle"
                    }
                    onClick={this.toggleGraphView}
                  >
                    <Icon name="abb/trend-3" sizeClass="small" />
                  </button>
                )}
              </ul>
              <div className="divider"></div>
              <div className="table-data-container">
                <form>
                  <table className="table propertyTable table-striped">
                    <thead>
                      <tr>
                        <th className="instrument">
                          <div className="measureItems cursor-default">
                            <div className="details">
                              <p className="title">
                                {this.props.selectedKeyedInDetails.name}
                              </p>
                              {(this.props.selectedKeyedInDetails.counts && this.props.selectedKeyedInDetails.counts.length && this.props.selectedKeyedInDetails.counts[0].totalCounts === this.props.selectedKeyedInDetails.counts[0].completedCounts) || (this.props.selectedKeyedInDetails.status.name &&
                                this.props.selectedKeyedInDetails.status.name.toString() ===
                                Status.COMPLETED) ? (
                                <p className="statusGreen">
                                  {t(Status.COMPLETED)}
                                </p>
                              ) : this.props.selectedKeyedInDetails.status
                                .name &&
                                this.props.selectedKeyedInDetails.status.name.toString() ===
                                Status.INPROGRESS ? (
                                <p className="statusGray">
                                  {t(Status.INPROGRESS)}
                                </p>
                              ) : this.props.selectedKeyedInDetails.status.name.toString() ===
                                Status.PENDING ? (
                                <p className="statusGray">
                                  {t(Status.PENDING)}
                                </p>
                              ) : this.props.selectedKeyedInDetails.status.name.toString() ===
                                Status.STOPPED ? (
                                <p className="statusGray">
                                  {t(Status.STOPPED)}
                                </p>
                              ) : <></>}
                              <p>
                                {
                                  this.props.selectedKeyedInDetails.counts[0]
                                    .completedCounts
                                }{" "}
                                (
                                {
                                  this.props.selectedKeyedInDetails.counts[0]
                                    .totalCounts
                                }
                                )
                              </p>
                              <progress
                                value={
                                  this.props.selectedKeyedInDetails.counts[0]
                                    .completedCounts
                                }
                                max={
                                  this.props.selectedKeyedInDetails.counts[0]
                                    .totalCounts
                                }
                              >
                                {" "}
                                {
                                  this.props.selectedKeyedInDetails.counts[0]
                                    .completionPercentage
                                }{" "}
                              </progress>
                            </div>
                          </div>
                        </th>

                        {this.props.selectedKeyedInDetails.directionCounts.map(
                          (item: any) => {
                            return (
                              <th className="property">
                                <div className="measureItems cursor-default">
                                  {" "}
                                  <div className="details">
                                    <p className="title">{item.name}</p>
                                    {item.completedCounts ===
                                      item.totalCounts ? (
                                      <p className="statusGreen">
                                        {t(Status.COMPLETED)}
                                      </p>
                                    ) : (
                                      <p className="statusGray">
                                        {t(Status.PENDING)}
                                      </p>
                                    )}
                                    <p>
                                      {" "}
                                      {item.completedCounts} ({item.totalCounts}
                                      )
                                    </p>
                                  </div>
                                  <progress
                                    value={item.completedCounts}
                                    max={item.totalCounts}
                                  >
                                    {" "}
                                  </progress>
                                </div>
                              </th>
                            );
                          }
                        )}
                      </tr>
                    </thead>
                    {!this.state.toggleGraph ? (
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              {this.props.selectedKeyedInDetails.name}
                            </span>
                            {this.props.selectedKeyedInDetails?.propertyMean
                              ?.mean ? (
                              <span className="float-right">
                                (
                                {this.props.selectedKeyedInDetails?.propertyMean?.mean.toFixed(
                                  this.props.selectedKeyedInDetails?.decimals ?? 5
                                )}
                                )
                              </span>
                            ) : (
                              <span className="float-right">
                                {CONSTANTS.NOTCONSIDEREDFORCALC}
                              </span>
                            )}
                            <span className="float-right pr-4">
                              {this.props.selectedKeyedInDetails.unit}
                            </span>
                          </td>

                          {this.state.dummyState ? (
                            this.keyedInRowData()
                          ) : (
                            <></>
                          )}
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>{this.keyedInGraphData()}</tbody>
                    )}
                  </table>
                </form>
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
